import { Component, isDevMode } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { environment } from 'src/environments/environment';
import { MessageService } from 'src/app/services/message/message.service';
import { SpinnerText } from 'src/app/services/message/message.enum';
import { AimsCommonTableHeader, AimsCommonTablePermissions, AimsCommonTableHeaderType } from '@aims/common-components';
import { tap } from 'rxjs/operators';
import { delay } from 'rxjs/operators';
import { GetTextPipe } from 'src/app/pipes';


@Component({
  selector: 'dashboard',
  templateUrl: './dashboard.component.html',
  providers: [GetTextPipe]
})

export class DashboardComponent {

  constructor(
    private transferHttp: TransferHttpService,
    public permissionsService: PermissionsService,
    private messageService: MessageService,
    private getTextPipe: GetTextPipe) {}

  //***************************
  // Variables
  //***************************
  canCreate = this.permissionsService.canCreate(this.permissionsService.ComponentID.GroupPermissions);
  canUpdate = this.permissionsService.canUpdate(this.permissionsService.ComponentID.GroupPermissions);
  canDelete = this.permissionsService.canDelete(this.permissionsService.ComponentID.GroupPermissions);
    //***************************
  permissions: AimsCommonTablePermissions = {create:false,update:false,delete:false, export:false}

  //Table
  dashboard:Observable<any> = this.getDashboard();
  dashboardDataSource: any[];
  dashboardColumns: AimsCommonTableHeader[] = [
    { 
      key: 'componentId', label: 'Component', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => 
        this.getTextPipe.transform(element.componentId, 'componentId', 'component', this.components) 
      } 
    },
    { 
      key: 'createProvider', label: 'Create Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => 
        this.getTextPipe.transform(element.createProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues) 
      }
     },
    { key: 'create', label: 'Create', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'readProvider', label: 'Read Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => 
        this.getTextPipe.transform(element.readProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues) 
      }
     },
    { key: 'read', label: 'Read', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'updateProvider', label: 'Update Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => 
        this.getTextPipe.transform(element.updateProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues) 
      } },
    { key: 'update', label: 'Update', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 },
    { key: 'deleteProvider', label: 'Delete Provider', type: AimsCommonTableHeaderType.DYNAMIC,
      events: { filterAndSort: (element) => 
        this.getTextPipe.transform(element.deleteProvider, 'permissionGroupId', 'permissionGroupName', this.groupValues) 
      } },
    { key: 'delete', label: 'Delete', type: AimsCommonTableHeaderType.DYNAMIC, filterType:'boolean', width:90 }
  ];
  user = this.transferHttp.getCache('user');

  components;
  groupValues;

  //Spinner
  spinnerText: string = this.messageService.getSpinnerText(SpinnerText.Load);
  showSpinner: boolean = true;

  imgSrc: string = environment.assetsPath;

  //***************************
  // Functions
  //***************************

  getDashboard(){
    this.showSpinner = true;
    return this.permissionsService.getUserPermissions().pipe(
      delay(0),
      tap(perms=> {
        this.showSpinner = false;
        this.dashboardDataSource = perms;
      })
    );
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
    this.spinnerText = this.messageService.getSpinnerText(SpinnerText.Load);
    this.showSpinner = true;
    
    combineLatest(
      [this.permissionsService.getComponents(), this.permissionsService.getPermissionGroups()]
    ).subscribe(
      ([components,groups]) => {
      this.components = components;
      this.groupValues = groups;
      this.showSpinner = false;
    },
      err => this.showSpinner = false
    );
  }

}
